/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Moderationempty1Inputs */

const en_moderationempty1 = /** @type {(inputs: Moderationempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing to review`)
};

const de_moderationempty1 = /** @type {(inputs: Moderationempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nichts zu prüfen`)
};

/**
* | output |
* | --- |
* | "Nothing to review" |
*
* @param {Moderationempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const moderationempty1 = /** @type {((inputs?: Moderationempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Moderationempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_moderationempty1(inputs)
	return de_moderationempty1(inputs)
});
export { moderationempty1 as "moderationEmpty" }